<template>
  <div class="create-password-container">
    <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions"></OnboardingMenu>
    <div class="banner">
      <img :src="bannerUrl" alt="">
    </div>
    <div class="title">{{ $t('onboarding.nestle.createPassword') }}</div>
    <onboarding-divider />
    <div class="input-form-div">
        <onboarding-input :label="$t('onboarding.nestle.userName')" isEditable="false" v-model="userName"/>
        <onboarding-input :label="$t('onboarding.nestle.firstName')" isEditable="false" v-model="firstName"/>
        <onboarding-input :label="$t('onboarding.nestle.lastName')" isEditable="false" v-model="lastName" />
        <onboarding-input ref="password" :label="$t('onboarding.nestle.password')" isRequired="true" v-model="password" :tooltip="$t('onboarding.nestle.error.passwordTip')" type='password' regex='^(?![0-9_#@.-]+$)(?![a-zA-Z_#@.-]+$)(?![0-9a-z_#@.-]+$)(?![0-9A-Z_#@.-]+$)[0-9a-zA-Z_#@.-]{10,}$' />
        <onboarding-input ref="rePassword" :label="$t('onboarding.nestle.reEnterPassword')" isRequired="true" v-model="rePassword" type='password' :password="password" :errorMessage="repasswordError"/>
        <onboarding-checkbox-option v-if="showPolicy" class="privacy" :modal="policyModal" align="center" :text="$t('onboarding.nestle.agreeStatement')" v-model="agree"></onboarding-checkbox-option>
    </div>
    <div class="next-button">
        <onboarding-button :isDisabled="agree === '0' ? 'true' : 'false'" @click.native="submitPassword" :text="$t('onboarding.nestle.toEmployeePortal')" type='normal'></onboarding-button>
    </div>
  </div>
</template>
<script>
import OnboardingInput from '@/components/onboarding/form/Input'
import OnboardingDivider from '@/components/onboarding/form/Divider'
import OnboardingCheckboxOption from '@/components/onboarding/form/CheckboxOption'
import OnboardingButton from '@/components/onboarding/form/Button'
import { mapActions } from 'vuex'
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import { deviceType } from '@/utils/common'
import { passwordEncrypt } from '@/utils/rsa'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, OnboardingInput, OnboardingDivider, OnboardingCheckboxOption, OnboardingButton
  },
  data () {
    return {
      bannerUrl: '',
      loginCode: '',
      userName: '',
      firstName: '',
      lastName: '',
      password: '',
      rePassword: '',
      repasswordError: '',
      agree: '0',
      showPolicy: false
    }
  },
  computed: {
    policyModal () {
      return {
        title: this.$t('onboarding.nestle.statementTitle'),
        body: this.$t('onboarding.nestle.statementBody')
      }
    },
    isNestle () {
      return this.$parent.isNestle
    }
  },
  created () {
    if (this.isNestle) {
      this.showPolicy = true
      this.agree = '0'
    } else {
      this.showPolicy = false
      this.agree = '1'
    }
    this.getLoginInfo()
    this.initBannerUrl()
  },
  methods: {
    ...mapActions('onboarding', ['getLoginCodeInfo', 'createPassword']),
    ...mapActions('account', ['getSessionAccountInfo']),
    async getLoginInfo () {
      try {
        this.loginCode = this.$route.query.loginCode
        let loginCodeInfo = this.$parent.loginCodeInfo
        if (!loginCodeInfo) {
          loginCodeInfo = await this.getLoginCodeInfo({ loginCode: this.loginCode })
        }
        if (loginCodeInfo) {
          this.firstName = loginCodeInfo.first_name || ''
          this.lastName = loginCodeInfo.last_name || ''
          this.userName = loginCodeInfo.email_address || ''
        }
      } catch (err) {
        if (this.$route.query.email) {
          this.$router.push(`/onboarding/${this.invitationId}/login?email=${this.$route.query.email}`)
        } else {
          this.$router.push(`/onboarding/${this.invitationId}/login`)
        }
      }
    },
    initBannerUrl () {
      if (this.isNestle) {
        if (deviceType.isMobile) {
          this.bannerUrl = require('@/assets/image/onboarding/common/mobile-banner.jpg')
        } else {
          this.bannerUrl = require('@/assets/image/onboarding/common/banner.png')
        }
      } else {
        this.bannerUrl = this.$parent.headerImage
      }
    },
    async submitPassword () {
      if (this.agree === '0' || this.userName === '') {
        return
      }
      if (!this.$refs.password.validate() || !this.$refs.rePassword.validate()) {
        return
      }
      const passwordSame = this.password === this.rePassword
      if (!passwordSame) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.createPassword({ loginCode: this.loginCode, password: passwordEncrypt(this.password), rePassword: passwordEncrypt(this.rePassword) })
        if (resp) {
          await this.getSessionAccountInfo()
          await this.$parent.refreshInvitationInfo()
          this.$router.push(this.$parent.getOnboardingHomePath())
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
  .create-password-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .banner {
      img {
        background-size: cover;
        width: 100%;
        height: auto;
      }
    }
    .title {
      font-weight: bolder;
      margin-top: 2rem;
      margin-bottom: 1.2rem;
      text-align: center;
    }
    .divider {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2.5rem;
      float: none;
    }
    .input-form-div {
      width: 100%;
      padding: 0 5%;
    }
    .next-button {
      margin: 4rem 0;
      padding-bottom: 50px;
    }
  }
/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
  .privacy {
    position: relative !important;
    left: -50px !important;
  }
}
</style>
